let errImg = {
    bind: function (el, binding, vnode) {
        if (el.tagName === 'IMG') {
            el.addEventListener('error', function (event) {
                const arr = el.className.split(/\s+/);
                const idx = arr.indexOf('error-img');
                if (idx !== -1) {
                    arr.splice(idx, 1);
                    el.className = arr.join(' ');
                }
                if (el.className === '') {
                    el.className = 'error-img';
                } else {
                    el.className += ' error-img';
                }
                el.src = require('../common/img/error-jd.gif');
                const parent = el.parentNode;
                const computedStyle = window.getComputedStyle(parent, null);
                if (computedStyle.display === 'inline') {
                    parent.style.display = 'inline-block';
                }
                parent.style.position = 'relative';
            });
        }
    }
}

export default {
    errImg
}


// WEBPACK FOOTER //
// ./src/directive/directive.js